import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('meetingnotes_token')) { navigate('/'); return; }
    authApi.checkSetup().then(res => { if (res.data.setupRequired) navigate('/setup'); }).catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const res = await authApi.login({ email, password });
      localStorage.setItem('meetingnotes_token', res.data.token);
      navigate('/');
    } catch { setError('Ungültige Anmeldedaten'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 380, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 64, marginBottom: 12 }}>🎙️</div>
          <h1 style={{ color: '#f1f5f9', fontSize: 24, fontWeight: 700 }}>Meeting Notes</h1>
          <p style={{ color: '#64748b', marginTop: 4 }}>KI-gestützte Meetingprotokolle</p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-Mail" required style={inputStyle} />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Passwort" required style={inputStyle} />
          {error && <p style={{ color: '#f87171', fontSize: 14, textAlign: 'center' }}>{error}</p>}
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Anmelden...' : '🔐 Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
const inputStyle = { background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9', padding: '12px 16px', borderRadius: 8, fontSize: 16, outline: 'none', width: '100%' };
const btnStyle = { background: '#6366f1', color: 'white', border: 'none', padding: '14px', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' };
